import gsap from 'gsap';

class menuAcademy {
  constructor(context) {
    this.dropdowns = [...context.querySelectorAll('[data-toggle-academy-menu]')].map((element, index) => {
      const dropdown = element.nextElementSibling;
      let open = false;

      element.addEventListener('click', e => {
        e.preventDefault();
        this.toggleDropdown(index);
        return false;
      });

      return {
        open,
        dropdown,
        element
      };
    });
  }

  toggleDropdown(index) {
    if (!this.dropdowns[index].open) {
      this.closeAllDropdowns();
      this.openDropdown(index);
    } else {
      this.closeAllDropdowns();
    }
  }

  openDropdown(index) {
    gsap.to(this.dropdowns[index].dropdown, { height: 'auto' });
    this.dropdowns[index].open = true;
    this.dropdowns[index].element.setAttribute('aria-expanded', true);
  }

  closeDropdown(index) {
    gsap.to(this.dropdowns[index].dropdown, { height: 0 });
    this.dropdowns[index].open = false;
    this.dropdowns[index].element.setAttribute('aria-expanded', false);
  }

  closeAllDropdowns() {
    this.dropdowns.forEach((element, index) => {
      this.closeDropdown(index);
    }); 
  }
};

export default menuAcademy;